import styled from 'styled-components';
import RecoverPassword from './RecoverPassword';
import { media, colorSchema } from 'utils/style';
import passwordRecovery from 'assets/images/passwordRecovery.svg';

export default styled(RecoverPassword)`
  height: 100%;
  .recover-password {
    display: grid;
    grid-gap: 12px;
    grid-template-columns: repeat(4, 1fr);
    height: 100%;
    flex-direction: column;
    max-width: 1440px;
    margin: 0 auto;

    ${media.greaterThan('tablet')`
      grid-template-columns: repeat(12, 1fr);
    `}

    &__background {
      grid-column: 1 / span 4;
      grid-row: 1;

      ${media.greaterThan('tablet')`
        background: url(${passwordRecovery}) no-repeat 100% 0;
        grid-column: 3 / span 8;
        grid-row: 1;
        margin: 10rem 0;
      `}
    }

    &__container {
      ${media.greaterThan('tablet')`
        max-width: 372px;
        padding: 2rem 0;
      `}
    }

    &__back {
      align-items: center;
      color: ${colorSchema('primary')};
      display: flex;
      font-size: 1.8rem;
      margin-bottom: 2.8rem;

      svg {
        fill: ${colorSchema('primary')};
        margin-right: 0.4rem;
      }

      &:hover {
        text-decoration: underline;
      }
    }

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 3.2rem;
      font-weight: normal;
      line-height: 1.19;
      margin-bottom: 1.6rem;
    }

    &__text {
      color: ${colorSchema('grey700')};
      font-size: 2rem;
      line-height: 1.3;
      margin-bottom: 2.4rem;
    }

    &__form {
      width: 100%;
    }

    &__input {
      height: 48px;
      margin-bottom: 3.2rem;
      width: 100%;

      input {
        height: 48px;
      }

      &--error {
        margin-bottom: 0;
      }
    }

    &__label {
      display: flex;
      margin-bottom: 1rem;
    }

    &__submit {
      justify-content: flex-start;
      input {
        border-radius: 4px;
      }
    }

    &__error {
      background-color: ${colorSchema('error100')};
      border-width: 0 1px 1px 1px;
      border-style: solid;
      border-color: ${colorSchema('error500')};
      border-radius: 0 0 4px 4px;
      color: ${colorSchema('error900')};
      display: flex;
      font-size: 1.4rem;
      font-weight: 500;
      margin-bottom: 3.2rem;
      padding: 0.8rem;
      width: 100%;
    }

    &__resend {
      background: none;
      border: 0;
      color: ${colorSchema('primary')};
      cursor: pointer;
      display: inline-block;
      font-size: 2rem;
      padding: 0;
      line-height: 1.3;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
